import { render } from "./Index.vue?vue&type=template&id=47659a44&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=47659a44&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=47659a44&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47659a44"]])

export default __exports__